import { getFieldLabel } from '../../utils';
import { useTranslation } from 'react-i18next';
import { DateTimePicker, TimePicker } from '@mui/x-date-pickers';
import moment, { Moment } from 'moment';
import { FormFieldProps } from '.';
import {
  DateFieldDateTypes,
  getDatePickerViews,
} from 'components/GlobalDialog/AddFieldTemplate/utils';
import { FieldHelperText } from './FieldHelperText';

export function getDateFormat(dateType?: string) {
  switch (dateType) {
    case DateFieldDateTypes.Year:
      return 'YYYY';
    case DateFieldDateTypes.DateTime:
      return 'YYYY.MM.DD HH:mm';
    case DateFieldDateTypes.Time:
      return 'YYYY.MM.DD HH:mm';
    case DateFieldDateTypes.Date:
    default:
      return 'YYYY.MM.DD';
  }
}

export function DateField({
  disabled,
  field,
  error,
  value,
  onChange,
  helperText,
  name,
  defaultValue,
  inputProps,
  sx,
  isImported,
}: FormFieldProps) {
  const { t } = useTranslation();
  const { description, dateType } = field.fieldAttributes ?? {};
  const format = getDateFormat(dateType);
  const onChangeDate = (date: Moment | null) => {
    onChange({
      target: {
        name: name ?? '',
        value: date?.format(format) ?? null,
      },
    });
  };

  let momentDate;

  if (value !== undefined) {
    const parsed = moment(value as string);
    momentDate = parsed.isValid() ? parsed : null;
  } else if (value === undefined && defaultValue) {
    momentDate = moment(defaultValue as string);
  } else {
    momentDate = null;
  }

  return (
    <>
      {dateType !== DateFieldDateTypes.Time ? (
        <DateTimePicker
          disabled={disabled}
          readOnly={inputProps?.readOnly}
          ampm={false}
          value={momentDate}
          label={getFieldLabel({ field, t })}
          onChange={onChangeDate}
          onAccept={onChangeDate}
          minutesStep={1}
          views={getDatePickerViews(dateType)}
          format={format}
          sx={{
            '& .MuiInputBase-root': {
              background: isImported ? theme => theme.palette.grey[200] : null,
            },
            ...sx,
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              helperText: (
                <FieldHelperText
                  description={description}
                  helperText={helperText}
                  error={error}
                />
              ),
              error,
              name,
              InputLabelProps: {
                shrink: true,
              },
            },
          }}
        />
      ) : (
        <TimePicker
          disabled={disabled}
          readOnly={inputProps?.readOnly}
          sx={{
            '& .MuiInputBase-root': {
              background: isImported ? theme => theme.palette.grey[200] : null,
            },
            ...sx,
          }}
          ampm={false}
          value={momentDate}
          label={getFieldLabel({ field, t })}
          onChange={onChangeDate}
          slotProps={{
            textField: {
              fullWidth: true,
              helperText: (
                <FieldHelperText
                  description={description}
                  helperText={helperText}
                  error={error}
                />
              ),
              error,
              name,
              InputLabelProps: {
                shrink: true,
              },
            },
          }}
          minutesStep={1}
        />
      )}
    </>
  );
}
